module.exports = __webpack_public_path__ + "static/media/GLENS-AT-CRYSTL-CREEK-MASTER-DEED.605b9522.pdf";